import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';

/**
 * Shared save footer + validation-errors list for the three GT layer editors,
 * extracted to avoid duplication across PageSplitEditor, SheetSplitEditor, and RowEditor.
 */
export function EditorFooter({
    errors,
    onSave,
    isPending,
    saveLabel,
    testId,
}: {
    errors: string[];
    onSave: () => void;
    isPending: boolean;
    saveLabel: string;
    testId?: string;
}) {
    return (
        <>
            {errors.length > 0 && (
                <ul className="px-4 pt-3 space-y-1">
                    {errors.map((e) => (
                        <li key={e} className="text-xs text-destructive">
                            {e}
                        </li>
                    ))}
                </ul>
            )}

            <div className="px-4 py-3 border-t shrink-0">
                <Button
                    type="button"
                    className="w-full"
                    disabled={isPending || errors.length > 0}
                    onClick={onSave}
                    data-testid={testId}
                >
                    {isPending && (
                        <Loader2 className="h-4 w-4 mr-1 animate-spin" />
                    )}
                    {isPending ? 'Saving…' : saveLabel}
                </Button>
            </div>
        </>
    );
}
